import ModalML from './ModalML';
export default (props) => {
  return <ModalML {...props} />;
};
